import { render, staticRenderFns } from "./BillFormView.vue?vue&type=template&id=51a53e71&scoped=true&"
import script from "./BillFormView.vue?vue&type=script&lang=js&"
export * from "./BillFormView.vue?vue&type=script&lang=js&"
import style0 from "./BillFormView.vue?vue&type=style&index=0&id=51a53e71&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a53e71",
  null
  
)

export default component.exports